import angular from 'angular';
import { Registration } from '../model/registration';
import { getFirstSelectedInvoiceStream } from '@/shared/components/registration/registrationHelpers';
angular
  .module('cxRegistrations')
  .controller('TrainingDialogCtrl', [
    '$scope',
    '$element',
    '$http',
    'appUrls',
    'dataCache',
    'resourceFactorySvc',
    'flySvc',
    'dialogsSvc',
    'close',
    'registration',
    'settings',
    '$q',
    trainingDialogCtrl,
  ]);
function trainingDialogCtrl(
  $scope,
  $element,
  $http,
  appUrls,
  dataCache,
  resourceFactorySvc,
  flySvc,
  dialogsSvc,
  close,
  registration,
  settings,
  $q,
) {
  const vm = this;
  vm.showValidation = false;
  vm.saving = false;
  vm.settings = settings || {};
  vm.trainings = [];
  vm.isLoadingTrainings = false;
  vm.currentUser = dataCache.getArray('employee')?.userID;

  $scope.$watch(
    function() {
      return vm.registration;
    },
    function(newValue) {
      if (typeof newValue === 'undefined') return;

      if (!(vm.registration instanceof Registration)) {
        vm.registration = new Registration(vm.registration);
      }
      vm.loadTrainings();
    },
  );

  if (registration && typeof registration === 'object') {
    vm.registration = new Registration(registration);
  } else {
    vm.registration = new Registration({ type: 5 });
  }

  vm.loadTrainings = function() {
    vm.isLoadingTrainings = true;
    const userId = vm.registration.userId || vm.currentUser;
    const trainingId = vm.registration.training?.trainingId ?? vm.registration.trainingId ?? null;

    $http
      .get(`${appUrls.api}/api/TrainingEmployee/activeTrainingsByUserId`, {
        params: {
          userId: userId,
          trainingId: trainingId || undefined,
        },
      })
      .then(response => {
        vm.trainings = (response.data || []).map(t => ({
          ...t,
          label: t.trainingName,
        }));
        if (trainingId) {
          const selected = vm.trainings.find(t => String(t.trainingId) === String(trainingId));
          vm.registration.training = selected || null;
          vm.registration.trainingCompleted = selected.trainingEmployeeStatus === 2;
        }
      })
      .catch(error => {
        console.error('Failed to load trainings', error);
      })
      .finally(() => {
        vm.isLoadingTrainings = false;
      });
  };

  vm.selectTraining = function(resources) {
    vm.resources = resources || [];
    const selectedTrainingId =
      vm.registration.training?.trainingId ?? vm.registration.trainingId ?? null;
    if (selectedTrainingId) {
      vm.registration.trainingId = selectedTrainingId;

      const matchingTraining = vm.trainings.find(t => t.trainingId === selectedTrainingId);

      if (matchingTraining) {
        vm.registration.trainingCompleted = matchingTraining.trainingEmployeeStatus === 2;

        const trainingResourceId = vm.registration.training?.trainingResourceId ?? null;
        const matchingResource = vm.resources?.find(r => r.id === trainingResourceId);

        if (matchingResource) {
          vm.registration.resource = matchingResource;
        } else {
          vm.registration.resource = null;
        }
      } else {
        vm.registration.trainingCompleted = false;
      }
    } else {
      vm.registration.trainingId = null;
      vm.registration.trainingCompleted = false;
    }
  };

  resourceFactorySvc
    .get('relation')
    .names({ take: 20, includeInactive: false, crmTypes: [4] }, function(data) {
      vm.relations = data || [];

      if (vm.relations.length === 0) return;

      if (vm.relations.length === 1) {
        vm.registration.relation = vm.relations[0];
      } else if (!vm.registration.relation) {
        const relationId = dataCache.getAbsenceRelationIdForUser(vm.registration.userId);
        const relation = vm.relations.find(x => x.id === relationId);
        vm.registration.relation = relation || vm.relations[0];
      }
    });

  vm.selectRelation = function(relation) {
    if (!relation || !relation.id) {
      vm.registration.relation = null;
      vm.registration.invoiceStreamId = null;
      vm.registration.invoiceStream = null;
      return;
    }

    vm.registration.relation = relation;
    vm.registration.invoiceStream = getFirstSelectedInvoiceStream(relation);
    vm.registration.invoiceStreamId = vm.registration.invoiceStream?.id;
  };

  const registrationResource = resourceFactorySvc.get('registration');
  vm.save = function() {
    if (!vm.canSave() || vm.saving) return;
    if (vm.registration.training && vm.registration.training.trainingId) {
      vm.registration.trainingId = vm.registration.training.trainingId;
    } else {
      vm.registration.trainingId = null;
    }
    vm.saving = true;

    const saveOp = vm.registration.group
      ? registrationResource.update([vm.registration]).$promise
      : registrationResource.save([vm.registration]).$promise;

    saveOp
      .then(result => {
        vm.saving = false;
        $element.modal('hide');
        close(result[0], 500);
      })
      .catch(error => {
        flySvc.error(error);
        vm.saving = false;
      });
  };

  vm.canSave = () => !!vm.registration.resource && !!vm.registration.trainingId;

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
